module.exports = __webpack_public_path__ + "static/img/ad_wow.7dda6e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/contact/img/ad_wow.png
// module id = o4zb
// module chunks = 1